import colors, { TColors } from '@styles/variables/colors'

/**
 * Получить цвет
 */
export const getColor = (color: TColors) => colors[color]
